import { render } from "./MPSVLayout.vue?vue&type=template&id=5c672278"
import script from "./MPSVLayout.vue?vue&type=script&lang=js"
export * from "./MPSVLayout.vue?vue&type=script&lang=js"

import exportComponent from "/opt/microsoft-academy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__